import React from 'react';

const getRankTitle = (level) => {
  if (level < 5) return "The Initiate";
  if (level < 10) return "Seeker of Truth";
  if (level < 20) return "System Architect";
  if (level < 30) return "Grand Polymath";
  return "Madrearcal Leader";
};

const TopBar = ({ player, setShowSettings }) => {

  const pillStyle = {
    backgroundColor: 'var(--sidebar-bg)',
    border: '1px solid var(--accent-gold)',
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '42px',
    padding: '0 15px',
    color: 'var(--sidebar-text)',
    fontFamily: 'Courier Prime, monospace',
    boxShadow: 'inset 0 0 10px rgba(0,0,0,0.5), 0 4px 6px rgba(0,0,0,0.2)',
    boxSizing: 'border-box'
  };

  return (
    <header className="top-bar" style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'flex-end', 
      paddingBottom: '15px', 
      borderBottom: '1px dashed var(--accent-gold)', 
      marginBottom: '30px' 
    }}>

      {/* SOL TARAF: İSİM VE RANK */}
      <div className="header-title" style={{ display: 'flex', flexDirection: 'column' }}>
        <h2 style={{ 
          margin: 0, 
          fontFamily: 'Cinzel, serif', 
          fontSize: '2.4rem', 
          color: 'var(--sidebar-text)', 
          letterSpacing: '2px', 
          textTransform: 'uppercase', 
          textShadow: '1px 1px 5px rgba(0,0,0,0.5)' /* Çok daha yumuşak, elit bir gölge */
        }}>
          {player.name || "MADREARCAL POLYMATH"}
        </h2>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '8px' }}>
          
          {/* ASİL RANK BAŞLIĞI (Cırtlaklık Giderildi) */}
          <span style={{
            fontFamily: 'Cinzel, serif',
            fontWeight: 'bold',
            color: 'var(--accent-gold)', /* Cırtlak bordo yerine tok altın rengi */
            fontSize: '0.95rem',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            opacity: 0.9
          }}>
            {getRankTitle(player.level)}
          </span>

          {/* ELİT AYIRICI (Basit nokta yerine asil bir yıldız/elmas) */}
          <span style={{ color: 'var(--accent-red)', fontSize: '0.8rem', opacity: 0.7 }}>
            ✦
          </span>

          {/* LEVEL BİLGİSİ */}
          <span style={{ 
            fontFamily: 'Courier Prime, monospace', 
            color: 'var(--sidebar-text)', 
            fontSize: '0.9rem', 
            opacity: 0.6, /* Geri planda kalması için saydamlık artırıldı */
            letterSpacing: '1px',
            fontWeight: 'normal' 
          }}>
            LVL {player.level}
          </span>
        </div>
      </div>

      {/* SAĞ TARAF: STATLAR VE AYARLAR */}
      <div className="header-stats" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>

        {/* WEALTH PLAKETİ */}
        <div style={pillStyle}>
          <span style={{ fontSize: '1.2rem', color: 'var(--accent-gold)', marginRight: '8px' }}>⚜️</span>
          <span style={{ fontSize: '1.1rem', letterSpacing: '1px', fontWeight: 'bold' }}>
            {player.stats.wealth}
          </span>
        </div>

        {/* XP PLAKETİ */}
        <div style={pillStyle}>
          <span style={{ 
            fontFamily: 'Cinzel, serif', 
            color: 'var(--accent-gold)', 
            fontSize: '1rem', 
            marginRight: '8px', 
            fontWeight: 'bold' 
          }}>XP</span>
          <span style={{ fontSize: '1.1rem', letterSpacing: '1px', fontWeight: 'bold' }}>
            {player.xp} <span style={{ opacity: 0.4, fontWeight: 'normal', margin: '0 4px' }}>/</span> {player.xpToNext}
          </span>
        </div>

        {/* SETTINGS BUTONU */}
        <button
          onClick={() => setShowSettings(true)}
          style={{
            ...pillStyle,
            padding: '0',
            width: '42px',
            cursor: 'pointer',
            fontSize: '1.3rem',
            transition: 'all 0.2s'
          }}
          title="System Settings"
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--accent-red)';
            e.currentTarget.style.borderColor = '#ff4d4d';
            e.currentTarget.style.color = '#fff';
            e.currentTarget.style.boxShadow = '0 0 15px rgba(123, 17, 19, 0.8)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--sidebar-bg)';
            e.currentTarget.style.borderColor = 'var(--accent-gold)';
            e.currentTarget.style.color = 'var(--sidebar-text)';
            e.currentTarget.style.boxShadow = 'inset 0 0 10px rgba(0,0,0,0.5), 0 4px 6px rgba(0,0,0,0.2)';
          }}
        >
          ⚙️
        </button>
      </div>

    </header>
  );
};

export default TopBar;